import React from 'react';
import NavLinks from './NavLinks';
import type { User } from '../../../types';

type Props = {
  isAdmin?: boolean,
  isOwner?: boolean,
  isClient?: boolean,
  currentUser?: User,
  selectedUser?: User,
  onPayrollGeneratorClick?: Function,
  onMarketingStatsClick?: Function,
  onOpenCheckinModal?: () => void,
}

const NavCollapse = (props: Props): React.ReactElement => {
  const { currentUser, selectedUser, onPayrollGeneratorClick, onMarketingStatsClick, onOpenCheckinModal } = props;
  let { isAdmin, isOwner, isClient } = props;

  if (currentUser) {
    isClient = currentUser.role === 'client';
    isOwner = currentUser.role === 'owner';
    isAdmin = currentUser.role === 'admin';
  }

  return (
    <div className="text-center main-nav">
      <div className="collapse navbar-collapse" id="menu">
        <ul className="navbar-nav">
          {currentUser && currentUser.needsRemoteCheckin && (
            <li className="nav-item">
              <button
                type="button"
                className="btn btn-primary primary-color w-100 mb-2"
                onClick={() => {
                  onOpenCheckinModal?.();
                  // Close the collapsed menu
                  const menu = document.getElementById('menu');
                  if (menu) {
                    menu.classList.remove('show');
                  }
                }}
              >
                Check In
              </button>
            </li>
          )}
          <NavLinks isAdmin={isAdmin} isOwner={isOwner} isClient={isClient} selectedUser={selectedUser} onPayrollGeneratorClick={onPayrollGeneratorClick} onMarketingStatsClick={onMarketingStatsClick} />
        </ul>
      </div>
    </div>
  );
};

export default NavCollapse;
